import React from "react";
import { css } from "emotion";
import { useTranslation } from "react-i18next";
import makeCarousel from "react-reveal/makeCarousel";
import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";
import TransitionGroup from "react-transition-group/TransitionGroup";

import Container from "components/shared/Container";
import CarouselUI from "components/shared/Carousel";

import styleConfig from "styles/styleConfig";

const { margin } = styleConfig;
const Carousel = makeCarousel(CarouselUI, { defaultWait: 5000, maxTurns: 20 });

const slidesStyle = css`
  .slide {
    height: 300px;
    .content {
      position: absolute;
      bottom: 0;
      left: 0;
      margin-bottom: ${margin[6]};
      margin-left: ${margin[16]};
      h1 {
        font-weight: 900;
      }
    }
    img {
      display: block;
      height: 100%;
      margin: auto;
    }
  }
`;

interface Props extends React.PropsWithChildren {}

const SlideShow: React.FC<Props> = () => {
  const { t } = useTranslation();

  const transitionProps = {
    appear: false,
    enter: true,
    exit: true,
  };
  return (
    <div className={slidesStyle}>
      <Container className="container">
        <TransitionGroup {...transitionProps}>
          <Carousel>
            <Slide right>
              <Fade duration={2000} right>
                <div className="slide">
                  <div className="content">
                    <Fade top delay={1000}>
                      <h1>{t(`slideshow.easy_accessible`)}</h1>
                    </Fade>
                    <Fade bottom delay={1000}>
                      <p>{t(`slideshow.outside_lez`)}</p>
                    </Fade>
                  </div>
                  <img src="./assets/slideshow/slide1.jpg" alt="slide1" />
                </div>
              </Fade>
            </Slide>
            <Slide right className="slide">
              <Fade duration={2000} right>
                <div className="slide">
                  <div className="content">
                    <Fade top delay={1000}>
                      <h1>{t(`slideshow.always_fresh`)}</h1>
                    </Fade>
                    <Fade bottom delay={1000}>
                      <p>{t(`slideshow.erba_best`)}</p>
                    </Fade>
                  </div>
                  <img src="./assets/slideshow/slide2.jpg" alt="slide3" />
                </div>
              </Fade>
            </Slide>
            <Slide right className="slide">
              <Fade duration={2000} right>
                <div className="slide">
                  <div className="content">
                    <Fade top delay={1000}>
                      <h1>{t(`slideshow.all_you_need`)}</h1>
                    </Fade>
                    <Fade bottom delay={1000}>
                      <p>{t(`slideshow.diff_departments`)}</p>
                    </Fade>
                  </div>
                  <img src="./assets/slideshow/slide3.jpg" alt="slide3" />
                </div>
              </Fade>
            </Slide>
          </Carousel>
        </TransitionGroup>
      </Container>
    </div>
  );
};

export default SlideShow;
